import { isDebug, isMobileApp } from "@/constants";
import type { User } from "@dndbeyond/auth/types/user";

export const getWorkerName = (nodeEnv: string, env: string, user: User) =>
  JSON.stringify({
    isDebug,
    isMobileApp,
    nodeEnv,
    env,
    user,
  });
